module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_9.bb37118a50f948c2f29ed923807e7cd1.png";